import { render } from "./form_list.vue?vue&type=template&id=d2080d08&scoped=true"
import script from "./form_listComponent.js?vue&type=script&lang=js"
export * from "./form_listComponent.js?vue&type=script&lang=js"

import "./form_list.vue?vue&type=style&index=0&id=d2080d08&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d2080d08"]])

export default __exports__